import { Component } from '@angular/core';

@Component({
  selector: 'studio-sidebar-content-layout',
  templateUrl: './sidebar-content-layout.component.html',
  styleUrls: ['./sidebar-content-layout.component.scss'],
})
export class SidebarContentLayoutComponent {}
